import styled, { css } from "styled-components";

export const ComponentWrapper = styled.div`
  padding-bottom: 90px;
`;

export const CardWrapper = styled.div`
  margin-top: 29px;

  ${({ theme }) => css`
    .months-columns__card-fluxo-modalidade {
      display: flex;
    }

    .months-wrapper {
      width: 100%;
      padding: 3px;
      display: flex;
      overflow-x: scroll;
      white-space: nowrap;
    }
  `}
`;

export const CardFilled = styled.div`
  padding: 21.3px 19.5px 31px 20px;
  border-radius: 6px;
  background-color: #f6f6f6;
`;

export const Card = styled.div`
  padding: 21px 19px 15px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;
  ${({ theme }) => css`
    .border {
      border-right: solid 1px #b9b9ba;
    }
    .itens {
      margin: auto;
      width: 280px;
    }
    p {
      font-size: 11px;
      font-family: Roboto;
      color: #000;
      margin-left: 20px;
      margin: 28.3px 18px 47.5px 25.3px;
    }
  `}
`;

export const Separator = styled.div`
  height: 0;
  margin: 5px 1px 25px 1px;
  border-top: 1px solid #b9b9ba;
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const StatusButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 100%;
`;

export const WapperNote = styled.div`
  width: 100%;
  min-height: auto;
  margin-top: 6px;
  display: block;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
  background: #f6f6f6;
  overflow-y: scroll;

  /* Scrollbar: Wrapper */
  ::-webkit-scrollbar {
    height: 16px;
  }

  /* Scrollbar: Background */
  ::-webkit-scrollbar-track {
    background: #fff;
  }

  /* Scrollbar: Scroll */
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    height: 150px;
    border-radius: 8px;
    border: solid 3px #fff;
  }

  /* Scrollbar: Scroll on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`;

export const LabelNote = styled.div`
  font-size: 12px;
  font-family: Roboto;
  text-align: left;
  width: 100%;
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-bottom: 6px;
`;
